import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message, SelectItem } from 'primeng/api';
import { DataTable } from "primeng/components/datatable/datatable";
import { LazyLoadEvent } from "../../../models/DataTables/lazyLoadEvent";
import { INotificationContentType } from "../../../models/inModels/NotificationContentType";
import { NotificationTypeService } from "../../../services/notifications/notification.service";

@Component({
	selector: 'app-types',
	templateUrl: './types.component.html',
	styleUrls: ['./types.component.css']
})
export class TypesComponent {
	items: INotificationContentType[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];

	constructor(
		private service: NotificationTypeService,
		private router: Router) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 50;
	}


	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(event: INotificationContentType) {

		this.router.navigate(['notification/types/edit', event.Id]);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/notification/types/types.component.ts